import * as React from 'react';
import Modal from 'antd/lib/modal';
import message from 'antd/lib/message';
import { useGenericState } from 'src/Library/UseGenericState';
import { KycData } from './Types.masters';
import { fetchKycData } from 'src/api/masters';
import { FormComponentProps } from 'antd/lib/form';
import withStyles from 'react-jss';
import { commonStyles } from 'src/Library/CommonStyles';
import { StylesProps } from 'src/Library/Types';
import Loader from 'src/components/common/Loader';
import ViewKYC from './ViewKYC';

interface IProps extends StylesProps<ReturnType<typeof ViewKYCModalStyles>>,
  FormComponentProps {
    visible: boolean;
    onClose: () => void;
    onboardingId: string;
  }

interface StateProps {
  kycData: KycData[];
  isLoading: boolean;
}

const ViewKYCModalStyles = (theme) => ({
  ...commonStyles(theme),
});

const ViewKYCModal = (props: IProps) => {
  const {
    onboardingId,
    visible,
    classes,
  } = props;

  const [state, setState] = useGenericState<StateProps>({
      kycData: [],
      isLoading: false,
  });

  const {
    kycData,
    isLoading,
  } = state;

  const loadKycData = async () => {
    setState({
      isLoading: true
    });
    const response = await fetchKycData({
      onboardingId,
    });
    if (!response.isSuccess) {
      message.error(response.errorMessage);
    }
    setState({
      isLoading: false,
      kycData: response.isSuccess ? response.data.data : [],
    });
  };

  React.useEffect(() => {
    loadKycData();
  }, []);

  const handleClose = (success = false) => {
    props.onClose();
  }

  return <Modal
    visible={visible}
    closable={true}
    footer={false}
    width={600}
    title={'KYC Details'}
    className={classes.modal}
    onCancel={() => handleClose()}
  >
    <div
      className={classes.flexRowDiv}
      style={{ backgroundColor: '#F5F4F2', minHeight: '500px'}}
    >
      {isLoading ? <Loader zIndex={1000} /> : <ViewKYC kycData={kycData} onlyKYC={true}/>}
    </div>
  </Modal>;
};

export default withStyles(ViewKYCModalStyles)(ViewKYCModal);
